import {
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
  Switch,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Block } from "../../../../shared";
import { useThemeMode } from "../../../../../contexts/ThemeModeContext";
import { MoonIcon, SunIcon } from "../../../../../icons";

// iOS-style Switch (компактный)
const AppSwitch = styled(Switch)(({ theme }) => ({
  width: 46,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "220ms",
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.35)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor:
      theme.palette.mode === "dark" ? "#26262A" : "#E5E5EA",
    opacity: 1,
    transition: "background-color 220ms",
  },
}));

export function AppearanceBlock() {
  const { mode, toggleMode } = useThemeMode();
  const { t } = useTranslation("profile");
  const isDark = mode === "dark";

  return (
    <Block sx={{ paddingTop: "8px", paddingBottom: "8px" }}>
      <ListItem
        onClick={toggleMode}
        sx={{
          paddingTop: "8px",
          paddingBottom: "8px",
          paddingInline: 0,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          cursor: "pointer",
        }}
      >
        {/* Иконка выравнена по вертикальному центру двух строк текста
            (`alignSelf: center`, без верхнего margin) — так же, как в
            остальных блоках профиля. */}
        <ListItemIcon
          sx={(theme) => ({
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(51,119,255,0.16)"
                : "rgba(51,119,255,0.10)",
            color: theme.palette.primary.main,
            minWidth: "36px",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "10px",
            alignSelf: "center",
            flexShrink: 0,
          })}
        >
          {isDark ? <MoonIcon /> : <SunIcon />}
        </ListItemIcon>

        <ListItemText
          sx={{ margin: 0, flexGrow: 1 }}
          primary={
            <Typography sx={{ fontSize: "15px", fontWeight: 500 }}>
              {t("theme.title")}
            </Typography>
          }
          secondary={
            <Typography
              sx={{
                fontSize: "12px",
                color: "text.secondary",
                marginTop: "2px",
              }}
            >
              {isDark ? t("theme.on") : t("theme.off")}
            </Typography>
          }
        />

        <AppSwitch
          checked={isDark}
          onClick={(e) => e.stopPropagation()}
          onChange={toggleMode}
          inputProps={{ "aria-label": t("theme.toggle_aria") }}
          sx={{ flexShrink: 0 }}
        />
      </ListItem>
    </Block>
  );
}
